import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/chi-siamo")({
  head: () => seoMeta({
    title: "Chi siamo - LexAIPro",
    description: "La missione di LexAIPro: portare AI affidabile, citabile e privata al mondo legale italiano.",
    path: "/chi-siamo",
  }),
  component: () => (
    <ContentPage
      eyebrow="Azienda"
      title="Chi siamo"
      lead="Costruiamo strumenti AI che gli avvocati italiani possono usare con fiducia: precisi, citabili, conformi alla normativa europea."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Chi siamo",path:"/chi-siamo"}]}
      sections={[
        { heading: "La nostra missione", body: "Liberare i professionisti legali dal lavoro ripetitivo, restituendo tempo per ciò che conta: il rapporto con il cliente e il giudizio professionale." },
        { heading: "I nostri valori", bullets: ["Affidabilità prima di velocità","Privacy by design","Trasparenza sui limiti dell'AI","Made in EU"] },
      ]}
      cta={{ label: "Parla con noi", to: "/contatti" }}
      heroImage={pickContent(29)}
      updated="2026"
    />
  ),
});
